module.exports = __webpack_public_path__ + "static/media/boot.4cc6cc57.svg";